/* eslint-disable sort-keys */
export const PAYMENT_METHOD_OPTIONS = {
  direct_deposit: 'Direct Deposit',
  check: 'Paper Check',
  cash: 'Cash',
  direct_deposit_and_cash: 'Direct Deposit and Cash',
} as const;
/* eslint-enable sort-keys */

export type PaymentMethodValueT = keyof typeof PAYMENT_METHOD_OPTIONS;

export type PaymentMethodLabelT = typeof PAYMENT_METHOD_OPTIONS[PaymentMethodValueT];

export type PaymentMethodOptionT = {
    label: PaymentMethodLabelT;
    value: PaymentMethodValueT;
};

export const paymentMethodOptions: PaymentMethodOptionT[] = (Object
  .entries(PAYMENT_METHOD_OPTIONS) as [PaymentMethodValueT, PaymentMethodLabelT ][])
  .map(([value, label]) => ({ label, value }));
